import Axios from "axios";
const CancelToken = Axios.CancelToken;

export default
    {
        get(request) {
            var axios = Axios.create({ baseURL: process.env.SERVER_PATH });
            var source = CancelToken.source();
            var promise = axios.get(request, {
                cancelToken: source.token
            });
            return { promise: promise, cancel: source.cancel };
        },

        post(request, body) {

            if (!body)
                body = {};

            if (!body.token)
                body.token = localStorage.token;

            var axios = Axios.create({ baseURL: process.env.SERVER_PATH });
            var source = CancelToken.source();
            var promise = axios.post(request, body, {
                cancelToken: source.token
            });
            return { promise: promise, cancel: source.cancel };
        },

        initWebSocket() {
            // setup websocket
            if(window.location.protocol == "https:"){
                let url = "wss://" + window.location.host + "/nash";
                if (process.env.SERVER_PATH != "/nash") {
                    url = process.env.SERVER_PATH.replace("http", "wss");
                }
                return new WebSocket(url, "nash");
            }
            let url = "ws://" + window.location.host + "/nash";
            if (process.env.SERVER_PATH != "/nash") {
                url = process.env.SERVER_PATH.replace("http", "ws");
            }
            return new WebSocket(url, "nash");
        },
    }



// WEBPACK FOOTER //
// ./src/server.js